// extracted by mini-css-extract-plugin
export default {"recommendedFitContainer":"Dma-z","linkStyleCopy":"Ema-z","updatedSizingPrediction":"Fma-z","recommendedSize":"Gma-z","recommendedSizeCopy":"Hma-z"};